let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("c6MKV"), load("fwbht"), load("eWlhh")]).then(() => parcelRequire('3RRKD'));